export default "__VITE_ASSET__BvTPG4jR__"